import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {ServiceService} from './service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'ng2-meta';
declare var jQuery: any;

interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
  
}
@Component({
	//template: require('./news.component.html')
	templateUrl: './pg/service/service.component.html'
	
})

export class ServiceComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    
    public servicemain; 
    public service:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private metaService: MetaService,
	    private _pageService: ServiceService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''                 
				  	}		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	    
	  this._sub = this._route.params.subscribe(params => {
			let slug =params['slug'];
			
			this.servicemain=slug;
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);			   
			   this._pageService.getServicelist(slug).subscribe(
        data => {
                 //                 
                  this.pagedata.title=data.menu.link_showing_name;
                  this.pagedata.description=data.menu.link_showing_name; 
                  
                  if(data.menu.meta_description)                  
                  this.metaService.setTag('description',data.menu.meta_description);
                  
                  this.metaService.setTag('keywords',data.menu.meta_keywords);  
                                
                  if(data.menu.meta_title)
                  {
                       this._title.setTitle(data.menu.meta_title);
	                  this.metaService.setTag('og:title',data.menu.meta_title);
	                  

                  }
                 
                  else
                  this._title.setTitle(data.menu.link_showing_name);                  
                  this.service=data.service; 
                  let mainjs=this.shareService.getmainjs();
				   jQuery.getScript('./'+mainjs);
				                   
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);            
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/service/service.component.ts